import { AppButton, Empty, PagesHeader, Icon } from '@ui';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import i18n from '@/i18n';
import { ICONS } from '@/constants/icons';

/**
 * Catch-all route. Without it an unregistered path makes `<Routes>` render
 * `null`, which reads as an empty page rather than a broken link — the bug that
 * hid the missing `/fleet/drivers/:id/courses` route. Any future gap between a
 * `TABS[].path` and its `<Route>` now surfaces here instead of silently.
 */
export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div id="not-found">
      <PagesHeader
        IconComponent={() => <Icon name="warning" />}
        title={i18n.t('pagina_non_trovata', { defaultValue: 'Pagina non trovata' })}
        subtitle={location.pathname}
        leading={
          <AppButton
            mode="action"
            variant="primary"
            icon={ICONS.chevronLeft}
            title={i18n.t('indietro')}
            onClick={() => navigate(-1)}
          >
            {i18n.t('indietro')}
          </AppButton>
        }
      />
      <div className="content-wrapper">
        <div className="content pt-3">
          <div className="list-card">
            <Empty
              icon={ICONS.warning}
              title={i18n.t('pagina_non_trovata', { defaultValue: 'Pagina non trovata' })}
              message={i18n.t('pagina_non_trovata_msg', {
                defaultValue: 'Il percorso richiesto non esiste o non è più disponibile.',
              })}
              action={
                <AppButton mode="nav" variant="primary" onClick={() => navigate('/home')}>
                  {i18n.t('torna_alla_home', { defaultValue: 'Torna alla home' })}
                </AppButton>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
